import React from 'react';

import * as S from './icon.style.js'

const Icon = ({spriteClass, iconClass,}) => (
  <S.Icon className={`${spriteClass} ${iconClass}`}></S.Icon>
);

export default Icon;


